import React, { useState, useEffect, useCallback } from 'react';
import {
    Box,
    Typography,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery
} from '@mui/material';
import GenerateImageCard from '../GenerateImageCard/GenerateImageCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import { generateEventImages, getGenereatedImages , getModelName, enhancePrompt, enhancePromptVariation} from '../../services/apiService';
import { useLocation } from 'react-router-dom';
import { DynamicToastContent, showToast } from '../Toast/CommonToast';
import { toast } from "react-toastify";
import DiamondIcon from '@mui/icons-material/Diamond';
import { useNavigate } from 'react-router-dom';
import Loader from "../Loader/loader";
import { useCreditPoints } from '../../services/CreditPointsProvider';
import './ModalForm.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AspectRatioBox from '../Reusable/AspectRatioDesign';
import {useShowcaseWebSocket} from "../../context/ShowcaseProvider";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

// import { Image } from '../../types';

const styles = {
    container: {
        width: 400,
        padding: 2,
        backgroundColor: '#303058',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        color: '#fff',
        height: 720,
        marginTop: '10px',
        marginLeft: 4,
    },
    containerMobile: {

        padding: "10px",
        backgroundColor: '#303058',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        color: '#fff',
    },
    inputLabel: {
        color: '#B3b0c1',
        '&.Mui-focused': { color: '#B3b0c1' },
        '&:hover': { color: '#B3b0c1' },
    },
    button: {
        backgroundColor: '#3e3e5f',
    },
    generateButton: {
        backgroundColor: '#9146ff',
        '&:hover': { backgroundColor: '#803eff' },
        color: '#fff',
        fontWeight: 'bold',
    },
    generateContainer: {
        display: 'flex',
        gap: 2,
    }
};

interface CustomFormProps {
    trainingDetails?: any;
    path?: string;
    trainingId?: any
    allTrainings?: any;
    selectedType?: string;
    filteredImages?: any;
    modelId?: any;
}
// interface Response {
//     status: string; 
//     message: string;
//     data: any;
// }

const CustomForm = (props: CustomFormProps) => {
    const [aspectRatio, setAspectRatio] = useState<string>('landscape_4_3');
    const [count, setCount] = useState(1);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [prompt, setPrompt] = useState('');
    const [generatedImages, setGeneratedImage] = useState<any>([]);
    const userId = localStorage.getItem("userId");
    const [imageSource, setImageSource] = useState<any>([]);
    const location = useLocation();
    const navigate = useNavigate();
    const [generateLoader, setGenerateLoader] = useState<boolean>(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const isVerified = localStorage.getItem("isVerified");
    const { fetchCreditPoints} = useCreditPoints();
    const [modelDetails, setModelDetails] = useState<any>(null);
    const { responseData, reconnectWebSocket } = useShowcaseWebSocket();

    console.log("props", props.path)

   useEffect(() => {
    console.log("SocketResponse", responseData);
        if (responseData) {
            const responseArray = Array.isArray(responseData) ? responseData : [responseData];
            if (responseArray.length > 0) {
                setGeneratedImage((prev: any[]) => {
                    const safePrev = Array.isArray(prev) ? prev : [];
                    const allImages = [...responseArray, ...safePrev];
                    const uniqueImages = allImages.filter((img, index, arr) =>
                        arr.findIndex(item =>
                            (item._id && item._id === img._id) ||
                            (item.url && item.url === img.url)
                        ) === index
                    );
                    return uniqueImages;
                });
            }
            fetchCreditPoints(userId);
        }
    }, [responseData, fetchCreditPoints, userId]);




    const handleAspectRatioChange = (event: any) => {
        setAspectRatio(event.target.value);
    };

    const locationPath = location.pathname.startsWith(' /tryout/models');

// eventId
useEffect(()=>{
  fetchModelName();
},[props.modelId])

const fetchModelName = async()=>{
  try{
    const modelType:string = 'showcase';
    const response = await getModelName(modelType);
    console.log("modelshowcase", response);
    setModelDetails(response.data);
  }catch(error) {
    console.error("Error fetching model name:", error);
  }
}

const eventId = modelDetails?.find((model: any) => model.eventName === "Showcase")?._id ?? "6853fabf1c0892b44fc8be80";
localStorage.setItem("showcaseModelId", eventId);

const handleEnhancePrompt = async() => {
  if(prompt.trim().length === 0) {
    showToast("Please enter a prompt to enhance", "error");
    return;
  }
  try {
    const payload ={
      prompt: prompt,
    }
    const response = await enhancePrompt(payload);
    if(response.status === "success") {
      setPrompt(response.data);
      showToast(response.message, "success");
    } else {
      showToast(response.message, 'error');
    }
  } catch (error:any) {
    showToast(error?.message, 'error');
  }
};

const handleVariantPrompt = async() => {
  try {
    const payload ={
      prompt: prompt,
    }
    const response = await enhancePromptVariation(payload);
    if(response.status === "success") {
      setPrompt(response.data);
      showToast(response.message, "success");
    } else {
      showToast(response.message, 'error');
    }
  } catch (error:any) {
    showToast(error?.message, 'error');
  }
};
    // Fetch trainingId from props


    // console.log("Training Id", props.trainingDetails.trainingId);

    // Search/fetch generated images
    console.log("userId", userId, locationPath)
    const searchImages = useCallback(async () => {
        try {
            if (!props.trainingId) {
                throw new Error("trainingId is required");
            }
            const status = await getGenereatedImages(userId, props.trainingId, locationPath ? true : false);
            if (status.status === "success") {
                setGeneratedImage(status.data);
                const data = [];
                for (let i = 0; i < status.data.length; i++) {
                    data.push(status.data[i].url);
                }
                setImageSource(data);
            }
        } catch (err: any) {
            // handle error if needed
        }
    }, [props.trainingId, userId, locationPath]);

console.log("props", props)
    const handleGenerate = async () => {
        if (!props.modelId) {
            throw new Error("modelId is required");
        }
        reconnectWebSocket();
        setGenerateLoader(true);
        const generateData = {
            diffusersLoraFileUrl: props.path ? props.path.trim() : '', //whitespace removed, fallback to empty string
            prompt,
            userId: localStorage.getItem("userId"),
            modelId: props.modelId,
            trainingId: props.trainingId,
            imageSize: aspectRatio,
            numImages: count,
            creditsPoint:25,
            eventId: eventId,
        };

        try {
            const response = await generateEventImages(generateData);
            console.log("Generate Response", response);
            setGenerateLoader(false)


            if (response.status === "success") {
                showToast("Once image is generated it will be displayed in Generate Tab", "success");
                setImageSource((prev: any[]) => {
                    const all = [
                        response?.data?.imageGenerationId?.data[0]?.url,
                        ...(Array.isArray(prev) ? prev : [])
                    ].filter(Boolean);
                    return Array.from(new Set(all));
                });
                await fetchCreditPoints(userId);
                setPrompt("")

                //Deduct creditPoints Manually
                // const deductionPerImage = 25;
                // const totalDeduction = count * deductionPerImage;
                // const newCreditPoints = creditPoints - totalDeduction;
                // setCreditPoints(newCreditPoints);

                // setTimeout(() => {
                //     fetchCreditPoints(userId);
                // }, 5000);

            }
            else {
                showToast("Failed to generate image", "error");
                setPrompt("")
            }
             setPrompt("");
            
        } catch (error: any) {
            console.log(error.status)
            console.log(error.message)
            console.log(error);
            if (error.status === 402) {
                setGenerateLoader(false);
                localStorage.setItem("redirectLocation", location.pathname);
                const toastContent = (
                    <DynamicToastContent
                        icon={DiamondIcon}
                        message={error.message}
                        actionText="Buy Credits"
                        onActionClick={() => {
                            navigate("/subscription");
                        }}
                    />
                );

                // Display the toast
                toast(toastContent, {
                    autoClose: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                });
            }
            else {
                setGenerateLoader(false)
                showToast("An unexpected error occurred", "error");
            }
        }
    };

    useEffect(() => {
        if (isVerified === "false") {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    }, [isVerified]);

    useEffect(() => {
        if (!props.modelId || !props.modelId) {
            setIsButtonDisabled(true);
        } else {
            setIsButtonDisabled(false);
        }
    }, [props.modelId])

    // Call searchImages on mount and when trainingId/userId changes
    useEffect(() => {
        searchImages();
        const interval = setInterval(searchImages, 1 * 60 * 1000);
        return () => clearInterval(interval);
    }, [props.trainingId, userId, responseData, searchImages]);

    const handlePromptChange = (e: any) => {
        const input = e.target.value;
        setPrompt(input);
        setIsButtonDisabled(input.trim().length < 10);
    };

    const trainingStatus = props.trainingId || props?.trainingDetails?.trainingRequestStatus === "COMPLETED";
    const { trainingRequestStatus } = props.trainingDetails || {};

    return (
        <>
            {generateLoader && <Loader open={generateLoader}  />}
            <Box sx={styles.generateContainer}>
                {isMobile ? (
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <Accordion  sx={styles.containerMobile}>
                            <AccordionSummary style={{height:"40px !important"}} expandIcon={<ExpandMoreIcon style={{color:"white"}} />}>
                                <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Prodmpt</Typography>
                            </AccordionSummary>

                            <AccordionDetails style={{padding : "0px !important"}}>
                                <Box sx={styles.containerMobile}>
                            <Box className="promptImageContainer">
                            <ReusableButton
                            onClick={handleVariantPrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Variant with AI</ReusableButton>
                            <ReusableButton
                            onClick={handleEnhancePrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Enhance with AI</ReusableButton>
                          </Box>
                                    <TextField
                                        placeholder="Write Here..."
                                        label="Prompt"
                                        multiline
                                        minRows={7}
                                        maxRows={7}
                                        variant="outlined"
                                        className='textField'
                                        onChange={(e) => handlePromptChange(e)}
                                        value={prompt}
                                    />
                                    <FormControl variant="outlined" fullWidth className="selectField">
                                        <InputLabel>Aspect-ratio</InputLabel>
                                        <Select
                                            label="aspect-ratio"
                                            value={aspectRatio}
                                            onChange={handleAspectRatioChange}
                                            className='select'
                                            renderValue={(selected) => {
                                                let ratio = '';
                                                switch(selected) {
                                                  case 'square': ratio = '1:1'; break;
                                                  case 'portrait_4_3': ratio = '3:4'; break;
                                                  case 'portrait_16_9': ratio = '9:16'; break;
                                                  case 'landscape_4_3': ratio = '4:3'; break;
                                                  case 'landscape_16_9': ratio = '16:9'; break;
                                                  default: ratio = 'Select';
                                                }
                                                return (
                                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                   
                                                    {ratio}
                                                  </Box>
                                                );
                                            }}
                                        >
                                            <MenuItem value="">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <Box sx={{ width: 16, height: 16, border: '2px solid #ccc', borderRadius: '2px' }} />
                                                  Select
                                                </Box>
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="square" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="1:1" isSelected={aspectRatio === 'square'} />
                                                  1:1
                                                </Box>
                                                {aspectRatio === 'square' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="portrait_4_3" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="3:4" isSelected={aspectRatio === 'portrait_4_3'} />
                                                  3:4
                                                </Box>
                                                {aspectRatio === 'portrait_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="portrait_16_9" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="9:16" isSelected={aspectRatio === 'portrait_16_9'} />
                                                  9:16
                                                </Box>
                                                {aspectRatio === 'portrait_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="landscape_4_3" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="4:3" isSelected={aspectRatio === 'landscape_4_3'} />
                                                  4:3
                                                </Box>
                                                {aspectRatio === 'landscape_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="landscape_16_9" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="16:9" isSelected={aspectRatio === 'landscape_16_9'} />
                                                  16:9
                                                </Box>
                                                {aspectRatio === 'landscape_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                        </Select>
                                    </FormControl>

                                    <Box className="countContainer">
                                        <Typography className="countText">{count}</Typography>
                                        <Box className="buttonContainer">
                                            <Button
                                                onClick={() => setCount((prev) => Math.max(prev - 1, 1))}
                                                variant="contained"
                                                sx={styles.button}
                                            >
                                                -
                                            </Button>
                                            <Button
                                                onClick={() => setCount((prev) => Math.min(prev + 1, 5))}
                                                variant="contained"
                                                sx={styles.button}
                                            >
                                                +
                                            </Button>
                                        </Box>
                                    </Box>
                                    <ReusableButton
                                        onClick={handleGenerate}
                                        disabled={isButtonDisabled || trainingRequestStatus ==="in_progress"}
                                    >
                                        Generate (25 Credits)
                                    </ReusableButton>
                                </Box>
                            </AccordionDetails>

                        </Accordion>
                        <Box sx={{
        
                           
                        }}>
                            <GenerateImageCard isMobile imageSource={imageSource} trainingStatus={trainingStatus} generatedImages={generatedImages} />
                        </Box> 
                    </div>

                ) : (
                    <>
                        <Box sx={styles.container}>
                          
                            <Box className="promptContainer">
                                <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Prompt</Typography>
                            </Box>
                            <Box className="promptImageContainer">
                            <ReusableButton
                            onClick={handleVariantPrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Variant with AI</ReusableButton>
                            <ReusableButton
                            onClick={handleEnhancePrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Enhance with AI</ReusableButton>
                          </Box>
                            <TextField
                                placeholder="Write Here..."
                                label="Prompt"
                                multiline
                                minRows={7}
                                maxRows={7}
                                variant="outlined"
                                className='textField'
                                onChange={(e) => handlePromptChange(e)}
                                value={prompt}
                            />
                            <FormControl variant="outlined" fullWidth className="selectField">
                                <InputLabel>Aspect-ratio</InputLabel>
                                <Select
                                    style={{ height: "45px" }}
                                    label="aspect-ratio"
                                    value={aspectRatio}
                                    onChange={handleAspectRatioChange}
                                    className='select'
                                        renderValue={(selected) => {
                                            let ratio = '';
                                            switch(selected) {
                                              case 'square': ratio = '1:1'; break;
                                              case 'portrait_4_3': ratio = '3:4'; break;
                                              case 'portrait_16_9': ratio = '9:16'; break;
                                              case 'landscape_4_3': ratio = '4:3'; break;
                                              case 'landscape_16_9': ratio = '16:9'; break;
                                              default: ratio = 'Select';
                                            }
                                            return (
                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                
                                                {ratio}
                                              </Box>
                                            );
                                        }}
                                >
                                    <MenuItem value="">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <Box sx={{ width: 16, height: 16, border: '2px solid #ccc', borderRadius: '2px' }} />
                                          Select
                                        </Box>
                                      </Box>
                                    </MenuItem>
                                    <MenuItem value="square" className="selectBtn">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <AspectRatioBox ratio="1:1" isSelected={aspectRatio === 'square'} />
                                          1:1
                                        </Box>
                                        {aspectRatio === 'square' && <CheckCircleIcon color="success" fontSize="small" />}
                                      </Box>
                                    </MenuItem>
                                    <MenuItem value="portrait_4_3" className="selectBtn">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <AspectRatioBox ratio="3:4" isSelected={aspectRatio === 'portrait_4_3'} />
                                          3:4
                                        </Box>
                                        {aspectRatio === 'portrait_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                      </Box>
                                    </MenuItem>
                                    <MenuItem value="portrait_16_9" className="selectBtn">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <AspectRatioBox ratio="9:16" isSelected={aspectRatio === 'portrait_16_9'} />
                                          9:16
                                        </Box>
                                        {aspectRatio === 'portrait_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                      </Box>
                                    </MenuItem>
                                    <MenuItem value="landscape_4_3" className="selectBtn">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <AspectRatioBox ratio="4:3" isSelected={aspectRatio === 'landscape_4_3'} />
                                          4:3
                                        </Box>
                                        {aspectRatio === 'landscape_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                      </Box>
                                    </MenuItem>
                                    <MenuItem value="landscape_16_9" className="selectBtn">
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <AspectRatioBox ratio="16:9" isSelected={aspectRatio === 'landscape_16_9'} />
                                          16:9
                                        </Box>
                                        {aspectRatio === 'landscape_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                      </Box>
                                    </MenuItem>
                                </Select>
                            </FormControl>

                            <Box className="countContainer">
                                <Typography className="countText">{count}</Typography>
                                <Box className="buttonContainer">
                                    <Button
                                        onClick={() => setCount((prev) => Math.max(prev - 1, 1))}
                                        variant="contained"
                                        sx={styles.button}
                                    >
                                        -
                                    </Button>
                                    <Button
                                        onClick={() => setCount((prev) => Math.min(prev + 1, 5))}
                                        variant="contained"
                                        sx={styles.button}
                                    >
                                        +
                                    </Button>
                                </Box>
                            </Box>
                            <ReusableButton onClick={handleGenerate} disabled={isButtonDisabled || (!props.trainingDetails)}>Generate (25 Credits)</ReusableButton>
                        </Box>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: 2,
                            padding: '0px 30px',
                            height: 300,
                            marginTop: "0px",
                        }}>
                            <GenerateImageCard imageSource={imageSource} trainingStatus={trainingStatus} generatedImages={generatedImages} />
                        </Box>
                    </>

                )}


            </Box>
        </>
    );
};

export default CustomForm;